module.exports = __webpack_public_path__ + "img/personalResume.35147af7.png";